import type { Greeks } from '@apna/shared'

/*
 * `cls` is the hook the stylesheet collapses a column by — 9.25. It is
 * short because it appears on every greek cell of every row, and it is
 * spelled out here rather than derived from `key` so a grep for
 * `tr-g-gam` finds both this and the track that sizes it.
 */
const METRICS = [
  { key: 'gamma', cls: 'tr-g-gam', label: 'Gamma', decimals: 5 },
  { key: 'theta', cls: 'tr-g-the', label: 'Theta per day', decimals: 2 },
  { key: 'vega', cls: 'tr-g-veg', label: 'Vega per 1% IV', decimals: 2 },
  { key: 'rho', cls: 'tr-g-rho', label: 'Rho per 1% rate', decimals: 3 },
] as const

/** Aligned, non-interactive risk columns; provenance belongs in the header. */
export function GreeksCell({ greeks, side, why }: { greeks?: Greeks | null; side: 'ce' | 'pe'; why?: string }) {
  const metrics = side === 'ce' ? METRICS : [...METRICS].reverse()
  return metrics.map(({ key, cls, label, decimals }) => {
    const value = greeks?.[key]
    const rounded = value !== undefined && Number.isFinite(value) ? value.toFixed(decimals) : null
    const text = rounded === null ? '—' : Number(rounded) === 0 ? (0).toFixed(decimals) : rounded
    return <div key={key} className={`tr-cell tr-greek ${cls} num ${side === 'ce' ? 'tr-r' : 'tr-l'}`} title={why ?? label} data-greek={key}>{text}</div>
  })
}
